var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableReadOnly',{staticClass:"table--word-wraper",attrs:{"headerTable":_vm.headerTable,"items":_vm.orderActivities,"sortBy":"id","sortDesc":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }